import { formattedTime } from "@/lib/Util";

export function formatTime(value: string) {
  if (value) {
    return formattedTime(value);
  }
  return;
}